// TODO Add these into Locize if operations ask for it
export type THoliday = {
  name: string
  isPublicHoliday: boolean
}

// These days are taken from here
// https://dagarnir.is/
const maulYearlyHolidays: Record<string, Record<string, THoliday>> = {
  "2025": {
    "01.01": {
      name: "Nýársdagur",
      isPublicHoliday: true,
    },
    "06.01": {
      name: "Þrettándinn",
      isPublicHoliday: false,
    },
    "24.01": {
      name: "Bóndadagur, upphaf Þorra",
      isPublicHoliday: false,
    },
    "14.02": {
      name: "Valentínusardagurinn",
      isPublicHoliday: false,
    },
    "23.02": {
      name: "Konudagur, upphaf Góu",
      isPublicHoliday: false,
    },
    "03.03": {
      name: "Bolludagur",
      isPublicHoliday: false,
    },
    "04.03": {
      name: "Sprengidagur",
      isPublicHoliday: false,
    },
    "05.03": {
      name: "Öskudagur",
      isPublicHoliday: false,
    },
    "25.03": {
      name: "Kváradagur",
      isPublicHoliday: false,
    },
    "13.04": {
      name: "Pálmasunnudagur",
      isPublicHoliday: false,
    },
    "17.04": {
      name: "Skírdagur",
      isPublicHoliday: true,
    },
    "18.04": {
      name: "Föstudagurinn langi",
      isPublicHoliday: true,
    },
    "20.04": {
      name: "Páskadagur",
      isPublicHoliday: false,
    },
    "21.04": {
      name: "Annar í páskum",
      isPublicHoliday: true,
    },
    "24.04": {
      name: "Sumardagurinn fyrsti",
      isPublicHoliday: true,
    },
    "01.05": {
      name: "Baráttudagur verkalýðsins",
      isPublicHoliday: true,
    },
    "11.05": {
      name: "Mæðradagurinn",
      isPublicHoliday: false,
    },
    "29.05": {
      name: "Uppstigningardagur",
      isPublicHoliday: true,
    },
    "01.06": {
      name: "Sjómannadagurinn",
      isPublicHoliday: false,
    },
    "08.06": {
      name: "Hvítasunnudagur",
      isPublicHoliday: false,
    },
    "09.06": {
      name: "Annar í Hvítasunnu",
      isPublicHoliday: true,
    },
    "17.06": {
      name: "Þjóðhátíðardagur Íslendinga",
      isPublicHoliday: true,
    },
    "04.08": {
      name: "Frídagur verzlunarmanna",
      isPublicHoliday: true,
    },
    "09.08": {
      name: "Reykjavík Pride/Gleðigangan",
      isPublicHoliday: false,
    },
    "23.08": {
      name: "Menningarnótt í Reykjavík",
      isPublicHoliday: false,
    },
    "11.10": {
      name: "Fæðingardagur forseta (HT)",
      isPublicHoliday: false,
    },
    "25.10": {
      name: "Fyrsti vetrardagur",
      isPublicHoliday: false,
    },
    "31.10": {
      name: "Hrekkjavaka",
      isPublicHoliday: false,
    },
    "09.11": {
      name: "Feðradagurinn",
      isPublicHoliday: false,
    },
    "16.11": {
      name: "Dagur íslenzkrar tungu",
      isPublicHoliday: false,
    },
    "01.12": {
      name: "Fullveldisdagurinn",
      isPublicHoliday: false,
    },
    "24.12": {
      name: "Aðfangadagur jóla",
      isPublicHoliday: true,
    },
    "25.12": {
      name: "Jóladagur",
      isPublicHoliday: true,
    },
    "26.12": {
      name: "Annar í jólum",
      isPublicHoliday: true,
    },
    "31.12": {
      name: "Gamlársdagur",
      isPublicHoliday: true,
    },
  },
  "2026": {
    "01.01": {
      name: "Nýársdagur",
      isPublicHoliday: true,
    },
    "06.01": {
      name: "Þrettándinn",
      isPublicHoliday: false,
    },
    "23.01": {
      name: "Bóndadagur, upphaf Þorra",
      isPublicHoliday: false,
    },
    "14.02": {
      name: "Valentínusardagurinn",
      isPublicHoliday: false,
    },
    "16.02": {
      name: "Bolludagur",
      isPublicHoliday: false,
    },
    "17.02": {
      name: "Sprengidagur",
      isPublicHoliday: false,
    },
    "18.02": {
      name: "Öskudagur",
      isPublicHoliday: false,
    },
    "22.02": {
      name: "Konudagur, upphaf Góu",
      isPublicHoliday: false,
    },
    "24.03": {
      name: "Kváradagur",
      isPublicHoliday: false,
    },
    "29.03": {
      name: "Pálmasunnudagur",
      isPublicHoliday: false,
    },
    "02.04": {
      name: "Skírdagur",
      isPublicHoliday: true,
    },
    "03.04": {
      name: "Föstudagurinn langi",
      isPublicHoliday: true,
    },
    "05.04": {
      name: "Páskadagur",
      isPublicHoliday: false,
    },
    "06.04": {
      name: "Annar í páskum",
      isPublicHoliday: true,
    },
    "23.04": {
      name: "Sumardagurinn fyrsti",
      isPublicHoliday: true,
    },
    "01.05": {
      name: "Baráttudagur verkalýðsins",
      isPublicHoliday: true,
    },
    "10.05": {
      name: "Mæðradagurinn",
      isPublicHoliday: false,
    },
    "14.05": {
      name: "Uppstigningardagur",
      isPublicHoliday: true,
    },
    "24.05": {
      name: "Hvítasunnudagur",
      isPublicHoliday: true,
    },
    "25.05": {
      name: "Annar í Hvítasunnu",
      isPublicHoliday: true,
    },
    "07.06": {
      name: "Sjómannadagurinn",
      isPublicHoliday: false,
    },
    "17.06": {
      name: "Þjóðhátíðardagur Íslendinga",
      isPublicHoliday: true,
    },
    "03.08": {
      name: "Frídagur verzlunarmanna",
      isPublicHoliday: true,
    },
    "08.08": {
      name: "Reykjavík Pride/Gleðigangan",
      isPublicHoliday: false,
    },
    "22.08": {
      name: "Menningarnótt í Reykjavík",
      isPublicHoliday: false,
    },
    "11.10": {
      name: "Fæðingardagur forseta (HT)",
      isPublicHoliday: false,
    },
    "24.10": {
      name: "Fyrsti vetrardagur",
      isPublicHoliday: false,
    },
    "31.10": {
      name: "Hrekkjavaka",
      isPublicHoliday: false,
    },
    "08.11": {
      name: "Feðradagurinn",
      isPublicHoliday: false,
    },
    "16.11": {
      name: "Dagur íslenzkrar tungu",
      isPublicHoliday: false,
    },
    "01.12": {
      name: "Fullveldisdagurinn",
      isPublicHoliday: false,
    },
    "24.12": {
      name: "Aðfangadagur jóla",
      isPublicHoliday: true,
    },
    "25.12": {
      name: "Jóladagur",
      isPublicHoliday: true,
    },
    "26.12": {
      name: "Annar í jólum",
      isPublicHoliday: true,
    },
    "31.12": {
      name: "Gamlársdagur",
      isPublicHoliday: true,
    },
  },
}

// These days are taken from here
// https://valutaomregneren.dk/blog/helligdage
const tiffinYearlyHolidays: Record<string, Record<string, THoliday>> = {
  "2025": {
    "01.01": {
      name: "Nytårsdag",
      isPublicHoliday: true,
    },
    "24.03": {
      name: "Palmesøndag",
      isPublicHoliday: true,
    },
    "28.03": {
      name: "Skærtorsdag",
      isPublicHoliday: true,
    },
    "29.03": {
      name: "Langfredag",
      isPublicHoliday: true,
    },
    "31.03": {
      name: "Påskedag",
      isPublicHoliday: true,
    },
    "01.04": {
      name: "Anden Påskedag",
      isPublicHoliday: true,
    },
    "01.05": {
      name: "Arbejdernes kampdag",
      isPublicHoliday: false,
    },
    "09.05": {
      name: "Kristi himmelfartsdag",
      isPublicHoliday: true,
    },
    "19.05": {
      name: "Pinsedag",
      isPublicHoliday: true,
    },
    "20.05": {
      name: "Anden Pinsedag",
      isPublicHoliday: true,
    },
    "01.06": {
      name: "Grundlovsdag",
      isPublicHoliday: false,
    },
    "25.12": {
      name: "Juledag",
      isPublicHoliday: true,
    },
    "26.12": {
      name: "Anden Juledag",
      isPublicHoliday: true,
    },
    "31.12": {
      name: "Nytårsaften",
      isPublicHoliday: true,
    },
  },
}

export const holidaysByFsp = {
  maulYearlyHolidays,
  tiffinYearlyHolidays,
}
